import { defineMessages } from 'react-intl'

export default defineMessages({
  back: {
    id: 'Back',
    defaultMessage: 'Back'
  },
  loading: {
    id: 'Loading',
    defaultMessage: 'Loading...'
  },
  title: {
    id: 'OrganizationGroupsMembersPage.Title',
    defaultMessage: 'View and Search Group users'
  }
})
